import React, { FC } from 'react';
import PropTypes from 'prop-types';
import styles from './Filters.module.scss';

interface FiltersProps {
	children: JSX.Element | JSX.Element[] | any;
	clearAll?: boolean;
}

const Filters: FC<FiltersProps> = ({ children, clearAll }): JSX.Element => {
	return (
		<section className={styles.Filters}>
			{children}
			{clearAll && <span className={styles.ClearAll}>Clear All</span>}
		</section>
	);
};

Filters.propTypes = {
	clearAll: PropTypes.bool,
};

export { Filters };
